import "./StartYourProject.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import SyncWithUs from "./sections/SyncWithUs";
import AiLabAssistant from "./sections/AiLabAssistant";
import Footer from "@/reusable_sections/Footer";
export default function StartYourProjectPage() {
  return <div>
      <VoltMainHeader />
      <SyncWithUs />
      <AiLabAssistant />
      <Footer />
    </div>;
}